class StringUtils {
  public camelCaseToWords(camelCaseString: string): string {
    // Regular expression pattern to match camelCase
    const camelCasePattern = /([a-z])([A-Z])/g;

    // Replace camelCase with space and lowercase second match
    const result = camelCaseString
      .replace(camelCasePattern, '$1 $2')
      .toLowerCase();

    // Capitalize the first letter
    return result.charAt(0).toUpperCase() + result.slice(1);
  }
}

const stringUtils = new StringUtils();

export default stringUtils;
